// Firebase Configuration
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAZ2LZtFTosMvxR9yIEMlkfXXHaBdU5kTM",
  authDomain: "bonfimgourmet-cdb70.firebaseapp.com",
  projectId: "bonfimgourmet-cdb70",
  storageBucket: "bonfimgourmet-cdb70.firebasestorage.app",
  messagingSenderId: "211723723324",
  appId: "1:211723723324:web:72ca5eaf6b9dee10e69939",
  measurementId: "G-LGSNP7DGVP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Analytics (optional)
let analytics = null;
try {
  if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.warn("Analytics not available:", error.message);
}

export { analytics };
export default app;
